const dataRootUrl = "Data";

const getSiteSummary = `${dataRootUrl}/siteSummary`;

const getZoneSummary = `${dataRootUrl}/zoneSummary`;

const getCircuits = `${dataRootUrl}/circuits`;




const getSitePowerSummary = `${dataRootUrl}/sitePowerSummary`;

const getZonePowerSummary = `${dataRootUrl}/zonePowerSummary`;

const getCircuitsPower = `${dataRootUrl}/circuitsPower`;

const getDemand = `DemandData`;

const getPower = `PowerData`;

const getRealtime = `RealtimeData`;

const getSiteCostSummary = `${dataRootUrl}/siteCostSummary`;

const getZoneCostSummary = `${dataRootUrl}/zoneCostSummary`;

const getCircuitsCost = `${dataRootUrl}/circuitsCost`;

const getSiteTrendAnalysisSummary = `${dataRootUrl}/siteTrendAnalysisSummary`;

const getZoneTrendAnalysisSummary = `${dataRootUrl}/zoneTrendAnalysisSummary`;

const getCircuitsTrendAnalysis = `${dataRootUrl}/circuitsTrendAnalysis`;

const getSiteAnomalyDetectionSummary = `${dataRootUrl}/siteAnomalyDetectionSummary`;

const getZoneAnomalyDetectionSummary = `${dataRootUrl}/zoneAnomalyDetectionSummary`;

const getCircuitsAnomalyDetection = `${dataRootUrl}/circuitsAnomalyDetection`;

export default {
  getSiteSummary,
  getZoneSummary,
  getCircuits,
  getDemand,
  getPower,
  getRealtime,
  getSitePowerSummary,
  getZonePowerSummary,
  getCircuitsPower,
  getSiteCostSummary,
  getZoneCostSummary,
  getCircuitsCost,
  getSiteTrendAnalysisSummary,
  getZoneTrendAnalysisSummary,
  getCircuitsTrendAnalysis,
  getSiteAnomalyDetectionSummary,
  getZoneAnomalyDetectionSummary,
  getCircuitsAnomalyDetection
};
